module.exports = __webpack_public_path__ + "../resources/images/illustration_inbox-67cc327605b371868cc8e20d00e688c5.svg";